/**
 *
 * PasswordRecovery
 *
 */

import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import { Icon } from "@ant-design/compatible"
import {
  makeSelectSuccess,
  makeSelectError,
  makeSelectErrorMessage,
  makeSelectEmail,
  makeSelectLoading,
} from "./selectors"
import reducer from "./reducer"
import saga from "./saga"
import ForgottenPasswordForm from "../../components/ForgottenPasswordForm"
import ForgottenPasswordSuccess from "../../components/ForgottenPasswordSuccess"
import PageLogo from "../../components/PageLogo"
import { recoverWatcher, resetRecover } from "./actions"
import { LoadingOutlined } from "@ant-design/icons"
import { LanguageSelector } from "../../components/LanguageSelector"

/* eslint-disable react/prefer-stateless-function */
export class ForgottenPassword extends React.Component {
  state = {
    isLoadingComponent: true,
    logoInit: "",
  }

  loaderComponent = null

  UNSAFE_componentWillMount = () => {
    this.setState({ logoInit: "logo_loading_animated" })
  }

  componentDidMount = () => {
    this.loaderComponent = setTimeout(() => {
      return this.setState({ isLoadingComponent: false })
    }, 2800)
  }

  componentWillUnmount = () => {
    this.setState({ logoInit: "" })
    clearTimeout(this.loaderComponent)
  }

  render() {
    if (this.state.isLoadingComponent) {
      return (
        <div
          style={{
            background:
              "linear-gradient(360deg, rgba(0, 0, 0, 0.2) -2.87%, rgba(255, 255, 255, 0) 78.88%), #2E52F8",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}>
          <LoadingOutlined style={{ color: "white", fontSize: 50 }} />
        </div>
      )
    }

    return (
      <PageLogo>
        <LanguageSelector/>
        {this.props.success ? (
          <ForgottenPasswordSuccess
            {...this.props.email}
            onReset={this.props.onReset}
          />
        ) : (
          <ForgottenPasswordForm
            error={this.props.error}
            errorMessage={this.props.errorMessage}
            onRecover={this.props.onRecover}
            success={this.props.success}
            loading={this.props.loading}
            onReset={this.props.onReset}
          />
        )}
      </PageLogo>
    )
  }
}

ForgottenPassword.propTypes = { onRecover: PropTypes.func.isRequired }

const mapStateToProps = createStructuredSelector({
  error: makeSelectError(),
  errorMessage: makeSelectErrorMessage(),
  success: makeSelectSuccess(),
  email: makeSelectEmail(),
  loading: makeSelectLoading(),
})

function mapDispatchToProps(dispatch) {
  return {
    onRecover: (params) => dispatch(recoverWatcher(params)),
    onReset: () => dispatch(resetRecover()),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "ForgottenPassword", reducer })
const withSaga = injectSaga({ key: "ForgottenPassword", saga })

export default compose(withReducer, withSaga, withConnect)(ForgottenPassword)
